




import { Component, Vue, Prop } from 'vue-property-decorator';
import { FormQuestion } from '@/interfaces/registration/FormQuestion';
import { QuestionsModel } from '@/interfaces/registration/models/QuestionsModel';
import QuestionSection from './QuestionSection.vue';
import QuestionInput from './QuestionInput.vue';

@Component({
  components: {
    QuestionSection,
    QuestionInput
  }
})
export default class Question extends Vue {
  @Prop({ default: () => { return {}; } }) readonly formQuestion!: FormQuestion;
  @Prop({ default: () => { return []; } }) readonly value!: QuestionsModel;

  get questionComponent (): string {
    if (this.formQuestion.questionType === 'Section') {
      return 'QuestionSection';
    }
    return 'QuestionInput';
  }

  get model (): QuestionsModel {
    return this.value;
  }

  set model (newValue: QuestionsModel) {
    this.$emit('input', newValue);
  }
}
